/**
 * Maps a conversation's source channel (CHANNEL_ID) to a display label and
 * badge colour. Shared by the conversations list and detail views so the
 * Source badge is consistent everywhere.
 */
export interface ChannelMeta {
  label: string;
  cls: string;
}

export function channelMeta(channel: string | null): ChannelMeta {
  switch (channel) {
    case 'claude-ai':
      return { label: 'Claude.ai', cls: 'bg-indigo-100 text-indigo-800' };
    case 'claude-cowork':
      return { label: 'Claude cowork', cls: 'bg-indigo-100 text-indigo-800' };
    case 'claude-code':
      return { label: 'Claude Code', cls: 'bg-indigo-100 text-indigo-800' };
    case 'msteams':
      return { label: 'Teams', cls: 'bg-blue-100 text-blue-800' };
    case 'webchat':
    case 'directline':
      return { label: 'Web', cls: 'bg-gray-100 text-gray-800' };
    default:
      return { label: channel || '—', cls: 'bg-gray-100 text-gray-600' };
  }
}
